import { format } from 'date-fns'
import fetchGql from '~/utils/fetchGql'

const teamsDataQuery = gql`
  query TeampageItemsQuery($startsWith: String!) {
    TeampageItems(starts_with: $startsWith) {
      items {
        full_slug
        default_full_slug
        content {
          title
          heroImage {
            filename
            alt
          }
          shortDescription
        }
      }
    }
  }
`

const teamVacancyCountQuery = gql`
  query VacancypageItemsQuery($startsWith: String!, $slugs: String!, $filter: JsonScalar) {
    VacancypageItems(starts_with: $startsWith, by_slugs: $slugs, filter_query: $filter) {
      total
    }
  }
`

const parseTeamsData = (data: any) => {
  const teamData: any = data.TeampageItems
  const results: any = []

  teamData.items.forEach((item: any) => {
    results.push({
      slug: item.full_slug.replace(/^lv\//, '').replace(/^careers/, ''),
      code: item.default_full_slug
        .replace(/^lv\//, '')
        .replace(/^careers/, '')
        .split('/')
        .splice(-1)[0],
      ...item.content
    })
  })

  return results
}

const parseTeamVacancyCount = (data: any) => {
  const teamData: any = data.VacancypageItems
  return teamData.total
}

export const useFetchTeamData = () => {
  const fetchTeamsData = (language: string) => {
    const variables = {
      startsWith: (language === 'en' ? '' : `${language}/`) + 'careers/teams'
    }

    return fetchGql(teamsDataQuery, variables).then((response: any) => {
      return parseTeamsData(response)
    })
  }

  const fetchTeamVacancyCount = (language: string, team: string) => {
    const now = format(new Date(), 'yyyy-MM-dd')
    const variables: any = {
      startsWith: (language === 'en' ? '' : `${language}/`) + 'careers/vacancies/',
      slugs: `careers/vacancies/${team}/*`,
      filter: { internalDate: { gt_date: now } }
    }

    return fetchGql(teamVacancyCountQuery, variables).then((response: any) => {
      return parseTeamVacancyCount(response)
    })
  }

  return { fetchTeamsData, fetchTeamVacancyCount }
}
